var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"uk-position-relative base"},[_c('div',{staticClass:"base-items"},[_c('h5',{staticClass:"uk-padding-small uk-padding-remove-bottom uk-padding-remove-top"},[_vm._t("default")],2),_vm._v(" "),_vm._t("img")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }